import * as React from 'react';
import { AddOutlined, AddBoxOutlined, EditOutlined, DoneOutlined, KeyboardArrowLeft, KeyboardArrowRight, DeleteOutlined, FolderOutlined, Warning as WarningIcon } from '@mui/icons-material';
import Badge from '@mui/material/Badge';

function TimeframeBadge ({timeframe}) {
    if (!timeframe) {
        return (null);
    }
    //ega success, primary, secondary, need two more
    return (
        <span style={{marginLeft:'10px'}}>
            <Badge badgeContent={timeframe} color="success" />
            {timeframe}
        </span>
    );
}

function MisfitBadge ({entry}) {
    if (!entry) {
        return (null);
    }
    if (!Number(entry.num_leaf_children) || !Number(entry.num_nonleaf_children)) {
        return (null);
    }
    return ( //ega make it only show up in a certain mode
        <span style={{marginLeft:'10px'}}>
            <WarningIcon fontSize="small" />
        </span>
    );
}

export default function Entry ({entry, toggle, toggleActions, quickie, quickieTarget, add, edit, move, moveQuickie, complete, del, timeframe, pending, level, setCurrHoverEntry, copyingToClipboard}) {
    pending = pending || entry.pending;
    level = level ? level : 0;
    const containerStyle = {
        opacity: pending ? 0.5 : 1,
        cursor: 'pointer',
        position: 'relative',
    };
    const nameStyle = {
        paddingLeft: level * 10,
        textDecoration: (Number(entry.num_leaf_children) > 0 || Number(entry.num_nonleaf_children) > 0) ? 'underline' : 'none',
        width: '45%',
        maWidth: '45%',
        minWidth: '45%',
    };
    const actionBtnStyle = {
        paddingLeft: '20px',
        width: '45%',
        maWidth: '45%',
        minWidth: '45%',
    };
    const actionStyle = {
        width: '16%',
        minWidth: '16%',
        cursor: 'pointer',
        //backgroundColor: '#770000',
    };
    const timeframeStyle = {
        display: 'inline-block',
        width: '16%',
        minWidth: '16%',
        cursor: 'pointer',
    };
    const activeTimeframeStyle = {
        ...timeframeStyle,
        backgroundColor: '#776666',
    };
    let actionFunc = event => toggleActions(entry, event);
    let actionsLabel = 'actions';
    if (quickie === 'delete') {
        actionFunc = event => del(entry, event, false);
        actionsLabel = 'delete';
    }
    else if (quickie === 'complete') {
        actionFunc = event => complete(entry, event);
        actionsLabel = 'complete';
    }
    else if (quickie && quickie.includes('pri')) {
        actionFunc = event => timeframe(entry, (quickie === 'prix') ? null : Number(quickie.substring(3)), event);
        actionsLabel = 'Pri ' + quickie.substring(3);
    }
    else if (quickie && quickie.includes('move')) {
        actionFunc = event => moveQuickie(entry, event);
        actionsLabel = 'Move';
    }
    return (
        <>
            { true &&
                <div className="entry-container" style={containerStyle} onMouseOver={() => setCurrHoverEntry(entry)} onMouseLeave={() => setCurrHoverEntry(null)}>
                    <table style={{margin:0, padding:0, width:'100%', tableLayout:'fixed'}}><tbody><tr>
                        <td 
                            style={{fontWeight: (Number(entry.num_leaf_children) > 0 || Number(entry.num_nonleaf_children) > 0) ? 'bold' : 'normal', paddingLeft: level * 10, maxWidth:'75%', width:'75%', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}} 
                            onClick={(Number(entry.num_leaf_children) === 0 && Number(entry.num_nonleaf_children) === 0) ? null : (event => toggle(entry, event))}
                        >
                            {(copyingToClipboard && copyingToClipboard === Number(entry.id)) ? '--- copying to clipboard ---' : entry.name} 
                            <TimeframeBadge timeframe={entry.timeframe} />
                            <MisfitBadge entry={entry} />
                        </td>
                        <td onClick={actionFunc} style={{textAlign:'right', width:'25%'}}>{actionsLabel}</td>
                    </tr></tbody></table>
                </div>
            }
            { false &&
                <div className="entry-container" style={containerStyle}>
                    <span style={nameStyle} onClick={(Number(entry.num_leaf_children) === 0 && Number(entry.num_nonleaf_children) === 0) ? null : (event => toggle(entry, event))}>
                        {entry.name}
                    </span>
                    <span style={actionBtnStyle} onClick={event => toggleActions(entry, event)}>
                        actions
                    </span>
                </div>
            }
            { false &&
                <div onClick={event => toggleActions(entry, event)} className="entry-container" style={containerStyle}>
                    { (Number(entry.num_leaf_children) > 0 || Number(entry.num_nonleaf_children) > 0) && 
                        <span onClick={event => toggle(entry, event)} className="hoverHighlight" style={{paddingLeft:'20px', paddingRight:'20px'}}>
                            { Number(entry.expanded) === 0 ?
                                <KeyboardArrowRight />
                                :
                                <KeyboardArrowLeft />
                            }
                        </span>
                    }
                    { (Number(entry.num_leaf_children) === 0 && Number(entry.num_nonleaf_children) === 0) && 
                        <span style={{paddingLeft:'20px', paddingRight:'20px'}}>
                            <KeyboardArrowRight style={{visibility:'hidden'}} />
                        </span>
                    }
                    <span style={{cursor:'pointer', marginLeft:level*20}}>
                        {entry.name}
                    </span>
                </div>
            }
            { entry.showActions &&
                <>
                <div style={{width:'100%', textAlign:'center'}}>
                    <FolderOutlined style={actionStyle} className="actionBtn hoverHighlight" onClick={event => move(entry, event)} />
                    <AddOutlined style={actionStyle} className="actionBtn hoverHighlight" onClick={event => add(entry, false, event)} />
                    <AddBoxOutlined style={actionStyle} className="actionBtn hoverHighlight" onClick={event => add(entry, true, event)} />
                    <EditOutlined style={actionStyle} className="actionBtn hoverHighlight" onClick={event => edit(entry, event)} />
                    <DoneOutlined style={actionStyle} className="actionBtn hoverHighlight" onClick={event => complete(entry, event)} />
                    <DeleteOutlined style={actionStyle} className="actionBtn hoverHighlight" onClick={event => del(entry, event)} />
                </div>
                <div style={{width:'100%', textAlign:'center'}}>
                    <span style={Number(entry.timeframe) === 1 ? activeTimeframeStyle : timeframeStyle} className="actionBtn hoverHighlight" onClick={event => timeframe(entry, 1, event)}>1</span>
                    <span style={Number(entry.timeframe) === 2 ? activeTimeframeStyle : timeframeStyle} className="actionBtn hoverHighlight" onClick={event => timeframe(entry, 2, event)}>2</span>
                    <span style={Number(entry.timeframe) === 3 ? activeTimeframeStyle : timeframeStyle} className="actionBtn hoverHighlight" onClick={event => timeframe(entry, 3, event)}>3</span>
                    <span style={Number(entry.timeframe) === 4 ? activeTimeframeStyle : timeframeStyle} className="actionBtn hoverHighlight" onClick={event => timeframe(entry, 4, event)}>4</span>
                    <span style={Number(entry.timeframe) === 5 ? activeTimeframeStyle : timeframeStyle} className="actionBtn hoverHighlight" onClick={event => timeframe(entry, 5, event)}>5</span>
                    <span style={entry.timeframe === null ? activeTimeframeStyle : timeframeStyle} className="actionBtn hoverHighlight" onClick={event => timeframe(entry, null, event)}>x</span>
                </div>
                </>
            }
            { entry.loadingChildren &&
                <div style={{width:'100%', textAlign:'center', marginTop:'5px', marginBottom:'5px'}}>
                    Loading, hang on...
                </div>
            }
            { Number(entry.expanded) === 1 && entry.children &&
                <div className="children-container">
                { entry.children.map((child, i) =>
                    <Entry 
                        key={i} 
                        entry={child} 
                        toggle={toggle} 
                        toggleActions={toggleActions} 
                        quickie={quickie} 
                        quickieTarget={quickieTarget} 
                        add={add} 
                        edit={edit} 
                        move={move} 
                        moveQuickie={moveQuickie} 
                        complete={complete} 
                        del={del} 
                        timeframe={timeframe} 
                        pending={pending} 
                        level={level+1} 
                        setCurrHoverEntry={setCurrHoverEntry}
                        copyingToClipboard={copyingToClipboard}
                    />
                )}
                </div>
            }
        </>
    );
  }
  